/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import FormCheckboxField from '../../apiForm/form/input/CheckboxField';

export default function CheckboxField({
  inputKey,
  translation,
  language,
  control,
}: WrappedFunctionProps) {
  return (
    <FormCheckboxField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
    />
  );
}
